import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, AlertTriangleIcon } from 'lucide-react';
export function PremiumBonusSection() {
  // 15 minutes countdown timer
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  const premiumBonus1 = ['Plantilla profesional para presentar servicios contables', 'Modelo de propuesta para nuevos clientes', 'Guía para convertir consultas en clientes reales', 'Mejora la imagen profesional de tu estudio contable'];
  const premiumBonus2 = ['Plantillas para solicitar documentación a clientes', 'Modelos de recordatorio de vencimientos fiscales', 'Mensajes profesionales listos para usar', 'Estructura de comunicación mensual con clientes'];
  return <section className="relative overflow-hidden" style={{
    background: 'linear-gradient(180deg, #5e4316 0%, #caa64a 40%, #8a6a2a 100%)'
  }} data-id="element-238">
      {/* Metallic shine overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: 'linear-gradient(135deg, transparent 20%, rgba(255,255,255,0.08) 35%, transparent 50%, rgba(255,255,255,0.05) 65%, transparent 80%)'
    }} data-id="element-239" />

      {/* Top Red Bar with Timer */}
      <div className="w-full bg-red-600 py-3 px-4 shadow-lg flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 z-10 relative" data-id="element-240">
        <span className="text-white font-bold text-sm sm:text-base uppercase tracking-wider text-center" data-id="element-241">
          La oferta especial termina en
        </span>
        <div className="bg-white text-red-600 font-mono font-extrabold text-xl sm:text-2xl px-4 py-1 rounded shadow-inner" data-id="element-242">
          {formattedTime}
        </div>
      </div>

      <div className="py-16 px-4 max-w-5xl mx-auto relative z-10" data-id="element-243">
        {/* Intro Text */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-244">
          <span className="inline-block font-extrabold tracking-wider text-xs sm:text-sm uppercase px-5 py-2 rounded-full mb-6" style={{
          background: 'linear-gradient(135deg, #f1c40f 0%, #f9e076 50%, #caa64a 100%)',
          color: '#3a2a08',
          boxShadow: '0 4px 15px rgba(241,196,15,0.4)'
        }} data-id="element-245">
            Pero hoy pasa algo especial
          </span>
          <p className="text-xl md:text-2xl text-white font-medium leading-relaxed max-w-3xl mx-auto drop-shadow-md" data-id="element-246">
            Además del sistema de organización y los 6 bonos profesionales, hoy
            recibirás también dos{' '}
            <strong className="font-extrabold" style={{
            background: 'linear-gradient(135deg, #f1c40f, #f9e076, #caa64a)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }} data-id="element-247">
              BONOS PREMIUM
            </strong>{' '}
            diseñados para mejorar tu trabajo como contador independiente.
          </p>
        </motion.div>

        {/* Premium Bonus Cards */}
        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-248">
          {/* Card 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl p-6 md:p-8 flex flex-col relative" style={{
          background: 'linear-gradient(180deg, #0c1a2e 0%, #0a1425 100%)',
          border: '2px solid transparent',
          borderImage: 'linear-gradient(135deg, #caa64a, #f1c40f, #caa64a) 1',
          boxShadow: '0 8px 32px rgba(202,166,74,0.15), 0 0 20px rgba(241,196,15,0.08)'
        }} data-id="element-249">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 font-extrabold text-xs sm:text-sm uppercase tracking-wider px-4 py-1 rounded-full whitespace-nowrap" style={{
            background: 'linear-gradient(135deg, #caa64a 0%, #f9e076 50%, #f1c40f 100%)',
            color: '#3a2a08',
            boxShadow: '0 4px 12px rgba(241,196,15,0.35)'
          }} data-id="element-250">
              Bono Premium
            </div>
            {/* Book cover */}
            <div className="flex justify-center mt-4 mb-6 relative" data-id="element-251">
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-252">
                <div className="w-48 h-48 rounded-full bg-[#f1c40f]/10 blur-[50px]" data-id="element-253" />
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/8qEeWKMWB9qK8fANjKGjA1/sistema_para_conseguir_clientes_contables.png" alt="Sistema para conseguir clientes contables" className="h-52 sm:h-72 md:h-80 w-auto object-contain relative z-10" style={{
              filter: 'drop-shadow(0 20px 35px rgba(0,0,0,0.7))'
            }} data-id="element-254" />
            </div>
            <h3 className="text-base sm:text-xl md:text-2xl font-extrabold mb-4 sm:mb-6 leading-tight text-center" style={{
            background: 'linear-gradient(135deg, #f1c40f, #f9e076, #caa64a)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }} data-id="element-255">
              BONO PREMIUM #1 – SISTEMA PARA CONSEGUIR CLIENTES CONTABLES
            </h3>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-256">
              {premiumBonus1.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-257">
                  <div className="bg-[#f1c40f]/15 p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-258">
                    <CheckIcon className="w-4 h-4 text-[#f1c40f]" data-id="element-259" />
                  </div>
                  <span className="text-slate-300 font-medium leading-snug" data-id="element-260">
                    {item}
                  </span>
                </li>)}
            </ul>
            <div className="rounded-xl p-4 text-center" style={{
            background: 'linear-gradient(135deg, rgba(202,166,74,0.12) 0%, rgba(241,196,15,0.06) 100%)',
            border: '1.5px solid rgba(202,166,74,0.45)',
            boxShadow: '0 0 12px rgba(202,166,74,0.1)'
          }} data-id="element-261">
              <p className="font-bold" style={{
              background: 'linear-gradient(135deg, #f1c40f, #f9e076, #caa64a)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }} data-id="element-262">
                "Un sistema simple para conseguir nuevos clientes de forma
                profesional."
              </p>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl p-6 md:p-8 flex flex-col relative" style={{
          background: 'linear-gradient(180deg, #0c1a2e 0%, #0a1425 100%)',
          border: '2px solid transparent',
          borderImage: 'linear-gradient(135deg, #caa64a, #f1c40f, #caa64a) 1',
          boxShadow: '0 8px 32px rgba(202,166,74,0.15), 0 0 20px rgba(241,196,15,0.08)'
        }} data-id="element-263">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 font-extrabold text-xs sm:text-sm uppercase tracking-wider px-4 py-1 rounded-full whitespace-nowrap" style={{
            background: 'linear-gradient(135deg, #caa64a 0%, #f9e076 50%, #f1c40f 100%)',
            color: '#3a2a08',
            boxShadow: '0 4px 12px rgba(241,196,15,0.35)'
          }} data-id="element-264">
              Bono Premium
            </div>
            {/* Book cover */}
            <div className="flex justify-center mt-4 mb-6 relative" data-id="element-265">
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-266">
                <div className="w-48 h-48 rounded-full bg-[#f1c40f]/10 blur-[50px]" data-id="element-267" />
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/3zDHhvBzUea3Nz5iWEdfcv/sistema_de_comunicacion_profesional_con_clientes.png" alt="Sistema de comunicación profesional con clientes" className="h-52 sm:h-72 md:h-80 w-auto object-contain relative z-10" style={{
              filter: 'drop-shadow(0 20px 35px rgba(0,0,0,0.7))'
            }} data-id="element-268" />
            </div>
            <h3 className="text-base sm:text-xl md:text-2xl font-extrabold mb-4 sm:mb-6 leading-tight text-center" style={{
            background: 'linear-gradient(135deg, #f1c40f, #f9e076, #caa64a)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }} data-id="element-269">
              BONO PREMIUM #2 – SISTEMA DE COMUNICACIÓN PROFESIONAL CON CLIENTES
            </h3>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-270">
              {premiumBonus2.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-271">
                  <div className="bg-[#f1c40f]/15 p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-272">
                    <CheckIcon className="w-4 h-4 text-[#f1c40f]" data-id="element-273" />
                  </div>
                  <span className="text-slate-300 font-medium leading-snug" data-id="element-274">
                    {item}
                  </span>
                </li>)}
            </ul>
            <div className="rounded-xl p-4 text-center" style={{
            background: 'linear-gradient(135deg, rgba(202,166,74,0.12) 0%, rgba(241,196,15,0.06) 100%)',
            border: '1.5px solid rgba(202,166,74,0.45)',
            boxShadow: '0 0 12px rgba(202,166,74,0.1)'
          }} data-id="element-275">
              <p className="font-bold" style={{
              background: 'linear-gradient(135deg, #f1c40f, #f9e076, #caa64a)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent'
            }} data-id="element-276">
                "Un sistema para comunicarte con tus clientes de forma clara y
                profesional."
              </p>
            </div>
          </motion.div>
        </div>

        {/* Important Warning Block */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="rounded-2xl p-6 md:p-8 max-w-3xl mx-auto text-center relative overflow-hidden" style={{
        background: 'linear-gradient(180deg, #1a1005 0%, #0d0a04 100%)',
        border: '2px solid rgba(202,166,74,0.4)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.4), 0 0 15px rgba(202,166,74,0.1)'
      }} data-id="element-277">
          <div className="absolute top-0 left-0 w-full h-1" style={{
          background: 'linear-gradient(90deg, #caa64a, #f9e076, #f1c40f, #f9e076, #caa64a)'
        }} data-id="element-278" />
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-279">
            <AlertTriangleIcon className="w-6 h-6 text-[#f1c40f]" data-id="element-280" />
            <h4 className="text-xl font-extrabold uppercase tracking-wider" style={{
            background: 'linear-gradient(135deg, #f1c40f, #f9e076, #caa64a)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }} data-id="element-281">
              Importante
            </h4>
            <AlertTriangleIcon className="w-6 h-6 text-[#f1c40f]" data-id="element-282" />
          </div>
          <div className="space-y-3 text-slate-300 font-medium text-base md:text-lg" data-id="element-283">
            <p data-id="element-284">
              Estos dos sistemas <strong className="text-red-400" data-id="element-285">NO</strong>{' '}
              forman parte del sistema base.
            </p>
            <p data-id="element-286">
              Hoy están incluidos exclusivamente como{' '}
              <strong className="text-[#f1c40f]" data-id="element-287">BONOS PREMIUM</strong>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}